import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const variants = {
  primary:
    "bg-gold-primary text-aura-text hover:bg-gold-dark border border-gold-primary hover:border-gold-dark",
  outline:
    "bg-transparent text-aura-text border-2 border-gold-primary hover:bg-gold-primary/10",
  ghost: "bg-transparent text-gold-primary hover:bg-gold-light/20",
};

export default function Button({
  children,
  to,
  href,
  variant = "primary",
  className = "",
  ...props
}) {
  const base =
    "inline-flex items-center justify-center font-sans text-sm font-medium tracking-wide px-6 py-3 rounded-sm transition-all duration-300 " +
    variants[variant] +
    " " +
    className;

  if (to) {
    return (
      <Link to={to}>
        <motion.span
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
          className={base}
        >
          {children}
        </motion.span>
      </Link>
    );
  }

  if (href) {
    return (
      <a href={href} className={base} {...props}>
        {children}
      </a>
    );
  }

  return (
    <motion.button
      whileHover={{ scale: 1.02 }}
      whileTap={{ scale: 0.98 }}
      className={base}
      {...props}
    >
      {children}
    </motion.button>
  );
}
